import React from 'react';
import { bool, number } from 'prop-types';
import cn from 'classnames';
import { I18n } from '@fiverr-private/i18n-react';
import './styles.scss';

const BASE_KEY = 'reviews.helpful';
const TWO_PEOPLE_COUNT = 2;

const helpfulCountWithUserTextKey = (count) =>
    count === TWO_PEOPLE_COUNT ? `${BASE_KEY}.count_with_user_click.two` : `${BASE_KEY}.count_with_user_click`;

const HelpfulCount = ({ isHelpfulSelected = false, count = 0 }) => {
    if (count === 0) {
        return null;
    }

    return (
        <div className={cn('helpful-count', 'text-body-2')}>
            {!isHelpfulSelected ? (
                <I18n k={`${BASE_KEY}.count`} params={{ count }} />
            ) : (
                <I18n k={helpfulCountWithUserTextKey(count)} params={{ count, users: count - 1 }} />
            )}
        </div>
    );
};

HelpfulCount.propTypes = {
    isHelpfulSelected: bool,
    count: number,
};

export default HelpfulCount;
